export default __webpack_public_path__ + "static/media/img6.a4d8ce34.PNG";